import type { ReactNode } from "react";
import { useInView } from "../../hooks/useInView";

interface RevealProps {
  children: ReactNode;
  className?: string;
  /** Atraso em ms — use índices para criar efeito cascata (stagger). */
  delay?: number;
}

/**
 * Envolve o conteúdo com um fade + slide-up disparado quando entra na viewport.
 * O estilo vem das classes `.reveal` / `.is-visible` em index.css, que já
 * respeitam `prefers-reduced-motion`.
 */
export function Reveal({ children, className = "", delay = 0 }: RevealProps) {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <div
      ref={ref}
      className={`reveal ${inView ? "is-visible" : ""} ${className}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </div>
  );
}
